import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #f7f2fa;
`;

export const Header = styled.div`
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  margin-top: 20px;
  margin-right: 5px;
  margin-bottom: 5px;
`;
export const MarginHeading = styled.p`
  font-size: 16px;
  color: #000000;
  font-family: DM Sans;
  font-weight: 500;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: -5px;
`;

export const ApplyText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #000000;
  font-family: DM Sans;
  font-weight: 400;
`;

export const RowDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FirstRow = styled.div`
  display: flex;
  // //   align-items: center;
  // // justify-content: space-between;
`;
